const MENU_CONSTANT = {
  NINE_TILES: 9,
  FIVE_TILES: 5,
  SIX_TILES: 6,
  SEVEN_TILES: 7,
  BROWSE_CATEGORIES: 'browsecategory',
  VIEW_ALL_MENU: 'viewAllMenu',
  MENU: '/menu',
  ADD_TO_CART: 'addToCart',
  ITEM_QUANTITY: 1,
  ADDON_LIMITED_QUANTITY_PER_ORDER: 'AddOnLimitedQuantityPerOrder',
  ADDON_LIMITED_QUANTITY_PER_PRODUCT: 'AddOnLimitedQuantityPerProduct',
  CART_ADDONS: 'cart-addons',
  ADDONS: 'addons',
};
export default MENU_CONSTANT;
